import { render, staticRenderFns } from "./ContextMenuGroup.vue?vue&type=template&id=f3830922&"
import script from "./ContextMenuGroup.vue?vue&type=script&lang=js&"
export * from "./ContextMenuGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/directives/contextMenu/ContextMenuGroup.vue"
export default component.exports